import { Box, type SvgIconTypeMap, Typography } from '@mui/material'
import { type OverridableComponent } from '@mui/material/OverridableComponent'

import type React from 'react'
import { color } from 'config/color'

interface TagProps {
  type: 'error' | 'success'
  message: string
  Icon?: OverridableComponent<SvgIconTypeMap<unknown, 'svg'>> & {
    muiName: string
  }
}

export const Tag: React.FC<TagProps> = ({ type, message, Icon }) => {
  let bgcolor, border, iconColor, iconBgColor, textColor
  if (type === 'success') {
    bgcolor = color.success[50]
    border = `1px solid ${color.success[200]}`
    iconColor = color.success[600]
    iconBgColor = color.success[50]
    textColor = color.success[700]
  } else if (type === 'error') {
    bgcolor = color.error[50]
    border = `1px solid ${color.error[200]}`
    iconColor = color.error[600]
    iconBgColor = color.error[50]
    textColor = color.error[700]
  }

  return (
    <Box
      display="flex"
      flexDirection="row"
      bgcolor={bgcolor}
      border={border}
      p={0.5}
      borderRadius="4px"
      gap={0.5}
    >
      {Icon != null && (
        <Icon
          sx={{
            color: iconColor,
            backgroundColor: iconBgColor,
            fontSize: 20
          }}
        />
      )}
      <Typography fontSize={14} color={textColor}>
        {message}
      </Typography>
    </Box>
  )
}
